import { render, staticRenderFns } from "./GiteeOpenModal.vue?vue&type=template&id=2c20a921&"
import script from "./GiteeOpenModal.vue?vue&type=script&lang=js&"
export * from "./GiteeOpenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GiteeOpenModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GiteeOpenModal.vue
// module id = 2355
// module chunks = 1